/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {InputAndNumberFilterComponent} from './input-and-number-filter.component';
import {ReactiveFormsModule} from '@angular/forms';
import {TooltipModule} from '../../tooltip/tooltip.module';
import {FilterFooterModule} from '../filter-footer/filter-footer.module';
import {InputModule} from '../../input/input.module';

@NgModule({
    declarations: [InputAndNumberFilterComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        ReactiveFormsModule,
        TooltipModule,
        FilterFooterModule,
        InputModule
    ],
    exports: [InputAndNumberFilterComponent]
})
export class InputAndNumberFilterModule {

}
